import { graphql } from '__generated__';

import { useQueryStable } from '@/hooks/useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetMostExecutionFailedModels = graphql(/* GraphQL */ `
  query MostExecutionFailedModels($environmentId: BigInt!, $start: Date!, $end: Date!) {
    performance(environmentId: $environmentId) {
      mostExecutionFailedModels(start: $start, end: $end) {
        uniqueId
        isDeleted
        failurePercentage
        totalExecutions
        totalFailedExecutions
      }
    }
  }
`);

type MostExecutionFailedModelsParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  limit: number;
  pause?: boolean;
};

export const useMostExecutionFailedModels = ({
  environmentId = 0,
  startDate,
  endDate,
  limit = 5,
  pause,
}: MostExecutionFailedModelsParams) => {
  const query = useQueryStable({
    query: GetMostExecutionFailedModels,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      limit,
    },
    pause: pause || !environmentId || !startDate || !endDate || !limit,
  });

  return query;
};
